import React from "react";

const CarpetasList = ({ carpetas }) => {
   function convertirFechaLocal(fechaUTC) {
    const fecha = new Date(fechaUTC);
    return fecha.toLocaleString("es-AR");
}
  return (
    <div className="">
      {carpetas.length === 0 ? (
        <p className="">No hay carpetas disponibles</p>
      ) : (
        carpetas.map((carpeta) => (
          <div
            key={carpeta.id}
           style={{display:"flex",flexDirection:"column",maxWidth:"800px"}}
          >
           <hr/>
            <p className="text-sm text-gray-600">
              <strong>Fecha:</strong>{" "}
              {carpeta.fechaSolicitud
                ? new Date(carpeta.fechaSolicitud).toLocaleString()
                : "Desconocida"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Estado:</strong> {carpeta.estado || "Sin estado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Motivo:</strong>{" "}
              {carpeta.motivoSolicitud || "No especificado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Recepcionó:</strong>{" "}
              {carpeta.usuarioRecepciono || "No registrado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Medico Examino:</strong>{" "}
              {carpeta.medicoReviso || "No registrado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Tipo de Diagnostico:</strong>{" "}
              {carpeta.tipoDiagnostico || "No registrado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Diagnostico:</strong>{" "}
              {carpeta.diagnostico || "No registrado"}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Diagnostico o Tratamiento:</strong>{" "}
              {carpeta.diagnostico || "No registrado"}
            </p>
            {
                carpeta.iniciaCondicion?<><p className="text-sm text-gray-600">
                <strong>Inicia Condicion:</strong>{" "}
                {convertirFechaLocal(carpeta.iniciaCondicion) || ""}
              </p>
              <p className="text-sm text-gray-600">
              <strong>Finaliza Condicion:</strong>{" "}
              { convertirFechaLocal(carpeta.finalizaCondicion) || ""}
            </p>
            </>
              
              :""
            }
          </div>
        ))
      )}
    </div>
  );
};

export default CarpetasList;
